const planetOrbitStarsSVG = `\
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="111.919px" height="47.781px" viewBox="0 0 111.919 47.781" enable-background="new 0 0 111.919 47.781"
	 xml:space="preserve">
<g>
	<g>
		<g>
			<path fill="#3FD8B4" d="M56.404,7.178c-0.101,0.436,0.169,0.874,0.605,0.977l0.001,0.001l0.044,0.01
				C57.492,8.27,57.93,8,58.033,7.563c0.104-0.437-0.166-0.875-0.602-0.979l-0.048-0.012C56.946,6.47,56.508,6.741,56.404,7.178z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M47.481,28.358c-0.591,2.483,0.948,4.984,3.431,5.575c2.484,0.59,4.983-0.949,5.575-3.431
				c0.589-2.483-0.95-4.985-3.432-5.575C50.574,24.338,48.072,25.876,47.481,28.358z M49.063,28.735
				c0.383-1.61,2.004-2.609,3.615-2.225c1.61,0.383,2.61,2.005,2.227,3.616c-0.384,1.61-2.006,2.609-3.617,2.226
				C49.678,31.968,48.679,30.347,49.063,28.735z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M55.032,13.998c-0.378,1.589,0.606,3.189,2.195,3.567c1.588,0.377,3.189-0.606,3.566-2.196
				c0.378-1.587-0.607-3.188-2.195-3.565C57.01,11.426,55.411,12.411,55.032,13.998z M56.613,14.376
				c0.171-0.717,0.894-1.161,1.609-0.99c0.717,0.169,1.162,0.892,0.991,1.608c-0.17,0.715-0.892,1.162-1.61,0.991
				C56.888,15.813,56.444,15.092,56.613,14.376z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M43.145,22.263c-0.05,0.209-0.015,0.432,0.099,0.615c0.111,0.183,0.294,0.314,0.503,0.364
				c0.208,0.05,0.433,0.015,0.614-0.098c0.182-0.112,0.315-0.295,0.365-0.504c0.049-0.208,0.013-0.431-0.1-0.613
				c-0.113-0.183-0.296-0.316-0.504-0.366c-0.208-0.049-0.433-0.013-0.614,0.1C43.327,21.87,43.194,22.055,43.145,22.263z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M48.917,1.884c-0.05,0.208-0.015,0.434,0.099,0.615c0.111,0.182,0.295,0.314,0.503,0.365
				c0.208,0.049,0.433,0.013,0.614-0.1c0.182-0.111,0.316-0.295,0.365-0.504c0.049-0.208,0.013-0.432-0.099-0.614
				c-0.112-0.183-0.294-0.314-0.503-0.364c-0.208-0.051-0.433-0.014-0.615,0.098S48.966,1.677,48.917,1.884z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M34.456,13.245c-0.049,0.208-0.012,0.432,0.099,0.614c0.113,0.182,0.296,0.315,0.504,0.364
				c0.208,0.05,0.432,0.013,0.615-0.098c0.181-0.112,0.315-0.296,0.364-0.504c0.05-0.207,0.014-0.433-0.098-0.614
				c-0.113-0.182-0.297-0.315-0.504-0.365c-0.208-0.048-0.432-0.013-0.614,0.099C34.64,12.853,34.505,13.036,34.456,13.245z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M55.345,21.963c-0.049,0.208-0.013,0.433,0.1,0.615c0.112,0.182,0.296,0.315,0.504,0.364
				c0.208,0.05,0.431,0.014,0.614-0.099c0.182-0.112,0.316-0.296,0.365-0.503c0.049-0.208,0.013-0.433-0.098-0.615
				c-0.112-0.182-0.296-0.315-0.504-0.365c-0.209-0.049-0.431-0.013-0.614,0.1C55.528,21.572,55.395,21.756,55.345,21.963z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M42.142,30.353c-0.05,0.208-0.014,0.431,0.099,0.615c0.112,0.181,0.295,0.314,0.504,0.364
				c0.208,0.049,0.432,0.014,0.614-0.099c0.183-0.112,0.316-0.295,0.365-0.503s0.013-0.433-0.1-0.615
				c-0.112-0.182-0.295-0.315-0.503-0.364c-0.208-0.049-0.433-0.014-0.614,0.098C42.324,29.96,42.192,30.145,42.142,30.353z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M62.94,44.165l1.987,3.229c0.116,0.193,0.301,0.317,0.504,0.365s0.423,0.02,0.614-0.098l3.229-1.988
				c0.382-0.235,0.5-0.737,0.266-1.119l-1.987-3.229c-0.235-0.382-0.736-0.501-1.118-0.266l-3.229,1.986
				C62.824,43.283,62.704,43.783,62.94,44.165z M64.751,44.006l1.844-1.135l1.136,1.845l-1.845,1.135L64.751,44.006z"/>
		</g>
		<g>
			<path fill="#3FD8B4" d="M33.408,25.495c0.081,0.053,0.168,0.089,0.257,0.11c0.325,0.077,0.676-0.052,0.869-0.347
				c0.245-0.375,0.141-0.883-0.235-1.127c-0.374-0.245-0.875-0.143-1.122,0.23c-0.001,0.003-0.003,0.006-0.005,0.008
				C32.926,24.746,33.032,25.25,33.408,25.495z"/>
		</g>
		<g>
			<g>
				<path fill="#3FD8B4" d="M31.125,37.221c1.14,1.851,3.066,3.109,5.621,3.715c1.757,0.419,3.812,0.53,6.111,0.316
					c1.797-0.168,3.681-0.529,5.608-1.066c0.302,0.089,0.605,0.17,0.913,0.244c4.521,1.075,9.189,0.326,13.145-2.109
					c3.958-2.438,6.729-6.267,7.805-10.787c0.073-0.308,0.136-0.614,0.192-0.923c1.348-1.479,2.519-2.999,3.479-4.529
					c3.011-4.798,3.607-9.164,1.686-12.289c-1.958-3.178-6.215-4.602-11.987-4.007c-0.447,0.047-0.771,0.446-0.725,0.893
					c0.045,0.447,0.446,0.771,0.891,0.725c5.119-0.528,8.824,0.624,10.438,3.242c1.581,2.57,0.985,6.326-1.681,10.573
					c-0.537,0.859-1.149,1.717-1.823,2.563c0.108-6.817-3.818-13.245-10.235-16.133c-0.41-0.184-0.89-0.001-1.075,0.408
					c-0.184,0.41-0.002,0.891,0.408,1.075c3.856,1.736,6.72,4.881,8.184,8.605c-0.707-0.182-1.453-0.216-2.194-0.091
					c-1.394,0.235-2.61,0.998-3.427,2.147c-0.819,1.15-1.14,2.55-0.905,3.941c0.235,1.393,0.999,2.609,2.148,3.426
					c0.088,0.063,0.185,0.107,0.283,0.129c0.313,0.075,0.654-0.042,0.851-0.32c0.261-0.366,0.175-0.873-0.191-1.133
					c-0.796-0.566-1.324-1.409-1.487-2.373c-0.163-0.963,0.06-1.933,0.626-2.729s1.409-1.324,2.371-1.487
					c0.9-0.151,1.806,0.031,2.57,0.519c0.478,1.96,0.588,4.029,0.271,6.101c-2.576,2.754-5.803,5.364-9.454,7.611
					c-3.649,2.247-7.433,3.953-11.053,5.011c-7.708-2.522-12.335-10.605-10.424-18.634c0.682-2.867,2.142-5.401,4.117-7.401
					c0.001,1.985,1.36,3.788,3.372,4.267c2.355,0.561,4.727-0.899,5.287-3.254c0.482-2.025-0.531-4.061-2.32-4.949
					c1.661-0.546,3.429-0.823,5.245-0.78c0.449,0.011,0.821-0.344,0.832-0.793c0.012-0.449-0.344-0.821-0.793-0.833
					c-3.92-0.093-7.809,1.172-10.947,3.563c-3.182,2.424-5.446,5.907-6.374,9.806c-1.076,4.52-0.327,9.188,2.109,13.145
					c1.764,2.865,4.259,5.108,7.219,6.537c-1.059,0.219-2.096,0.377-3.104,0.471c-4.993,0.466-8.614-0.694-10.196-3.265
					c-1.663-2.7-0.628-6.121,0.533-8.517c0.196-0.403,0.026-0.89-0.377-1.086c-0.404-0.195-0.89-0.027-1.086,0.377
					C29.661,31.103,29.504,34.587,31.125,37.221z M43.88,11.811c0.158-0.661,0.542-1.209,1.05-1.582
					c0.123-0.08,0.247-0.156,0.373-0.232c0.566-0.293,1.237-0.393,1.905-0.235c1.483,0.354,2.403,1.847,2.05,3.329
					c-0.354,1.483-1.846,2.402-3.329,2.048C44.446,14.787,43.527,13.293,43.88,11.811z M51.596,39.172
					c2.929-1.078,5.907-2.53,8.798-4.31s5.53-3.784,7.811-5.913C65.705,35.761,58.804,40.009,51.596,39.172z"/>
			</g>
			<path fill="#3FD8B4" d="M37.444,2.521l1.058,0.82l0.257,1.316c0.038,0.16,0.128,0.257,0.272,0.292
				c0.145,0.034,0.304-0.003,0.375-0.138l0.822-1.059l1.314-0.257c0.16-0.038,0.258-0.128,0.292-0.272
				c0.035-0.144-0.002-0.305-0.138-0.374l-1.057-0.821l-0.257-1.315c-0.047-0.125-0.173-0.23-0.282-0.257
				c-0.144-0.034-0.304,0.003-0.375,0.138l-0.822,1.059l-1.314,0.256c-0.161,0.038-0.259,0.129-0.293,0.272
				C37.262,2.325,37.345,2.458,37.444,2.521z"/>
		</g>
	</g>
	<path fill="#3FD8B4" d="M6.647,33.218l1.219,0.555l0.554,1.22c0.074,0.147,0.185,0.221,0.333,0.221s0.295-0.074,0.333-0.221
		l0.554-1.22l1.22-0.555c0.148-0.074,0.222-0.184,0.222-0.333c0-0.149-0.074-0.296-0.222-0.333l-1.22-0.554l-0.554-1.22
		c-0.074-0.11-0.223-0.185-0.333-0.185c-0.148,0-0.296,0.074-0.333,0.221l-0.554,1.219L6.647,32.59
		c-0.148,0.074-0.222,0.186-0.222,0.333S6.536,33.181,6.647,33.218z"/>
	<path fill="#3FD8B4" d="M107.487,2.624l1.217,0.555l0.556,1.219c0.074,0.148,0.184,0.221,0.331,0.221
		c0.148,0,0.298-0.073,0.335-0.221l0.556-1.219l1.217-0.555c0.148-0.074,0.221-0.185,0.221-0.333c0-0.147-0.072-0.296-0.221-0.333
		l-1.217-0.554l-0.556-1.219C109.854,0.074,109.704,0,109.591,0c-0.147,0-0.293,0.074-0.331,0.222l-0.556,1.22l-1.217,0.553
		c-0.15,0.075-0.224,0.186-0.224,0.334C107.264,2.476,107.374,2.587,107.487,2.624z"/>
	<path fill="#3FD8B4" d="M0.223,7.335l1.218,0.554l0.555,1.22C2.069,9.256,2.181,9.33,2.329,9.33c0.148,0,0.295-0.074,0.332-0.221
		l0.555-1.22l1.219-0.554c0.149-0.074,0.221-0.186,0.221-0.332c0-0.149-0.072-0.297-0.221-0.334L3.216,6.115l-0.555-1.22
		C2.587,4.784,2.44,4.711,2.329,4.711c-0.148,0-0.295,0.073-0.333,0.222l-0.555,1.22L0.223,6.706C0.074,6.78,0,6.892,0,7.039
		S0.111,7.297,0.223,7.335z"/>
</g>
</svg>

`;

export default planetOrbitStarsSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/planetOrbitStarsSVG.js